import PageMeta from "@/components/site/PageMeta";
import Hero from "@/components/site/Hero";
import ReviewsSplit from "@/components/site/ReviewsSplit";
import WhatYouGet from "@/components/site/WhatYouGet";
import CustomerExample from "@/components/site/CustomerExample";
import HowSolarPreview from "@/components/site/HowSolarPreview";
import FAQPreview from "@/components/site/FAQPreview";
import TransparencyFacts from "@/components/site/TransparencyFacts";
import MeetJeremy from "@/components/site/MeetJeremy";
import WhyION from "@/components/site/WhyION";
import ContactJeremy from "@/components/site/ContactJeremy";

export default function HomePage() {
  return (
    <main data-testid="home-page">
      <PageMeta
        title="Jeremy with ION Solar | Fredericksburg, VA Solar Guidance"
        description="Personal solar guidance for Fredericksburg and surrounding Virginia communities. Jeremy, a Navy veteran and authorized representative of ION Solar, helps homeowners read their electric bill and decide whether solar fits their home — no pressure."
      />
      <Hero />
      <ReviewsSplit />
      <WhatYouGet />
      <CustomerExample />
      <HowSolarPreview />
      <TransparencyFacts />
      <FAQPreview />
      <MeetJeremy compact />
      <WhyION />
      <ContactJeremy />
    </main>
  );
}
